import classNames from 'classnames';
import { SideTabType } from 'components/generics/buttons/SideTabs/types';
import { TopTabType } from 'components/generics/buttons/TopTabs/types';
import React, { HTMLAttributes, useState } from 'react';
import classes from './index.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  tabs: SideTabType[];
  onChangeTab: (tab: TopTabType) => void;
  tabClassName?: string;
  selectedTabClassName?: string;
  selectedIconClassName?: string;
  underlineClassName?: string;
  layoutId?: string;
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}

const SideTabs = ({
  tabs,
  onChangeTab,
  tabClassName,
  selectedTabClassName,
  selectedIconClassName,
  className,
  selectedTab,
  setSelectedTab,
}: Props) => {
  const tabClickHandler = (tab: SideTabType) => {
    setSelectedTab(tab.value);
    onChangeTab(tab);
  };

  return (
    <div className={classNames(classes.container, className)}>
      <ul>
        {tabs.map((item) => {
          const Icon = item.icon;
          return (
            <li
              key={item.label}
              className={classNames(
                item.value === selectedTab ? selectedTabClassName : '',
                tabClassName,
                item.className
              )}
              onClick={() => tabClickHandler(item)}
            >
              {Icon && (
                <Icon
                  className={classNames(
                    item.value === selectedTab ? selectedIconClassName : '',
                    classes.icon,
                    item.iconClassName
                  )}
                />
              )}
              {item.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SideTabs;
